<template>
  <section id="officeAdd">
    <el-dialog :title="title" :visible.sync="diaLogName" width="30%">
      <section>
        <el-form
          :model="form"
          :rules="rules"
          size="mini"
          ref="addFrom"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="上级部门" prop="parent.id">
            <el-select v-model="form.parent.id" placeholder="请选择" class="width100">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number
              v-model="form.sort"
              controls-position="right"
              class="width100"
              @change="handleChange"
              :min="-100"
              :max="100"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </section>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="submitForm('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

 <!-- 菜单新增 与修改 -->


<script>
import { officeListApi,officePutApi,officeAddApi,officeOneApi } from "@/api/api";

export default {
  data() {
    return {
      diaLogName: false,
      rules: {
        name: [{ required: true, message: "请输入部门名", trigger: "blur" }],
        "parent.id": [
          { required: true, message: "请选择父级部门", trigger: "blur" }
        ]
      },
      options: [],
      form: {
        id:"",
        name: "",
        sort: "",
        parent:{
          id:""
        }
      }
    };
  },
  props: {
    title: { type: String }
  },
  methods: {
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("submit!");
          if (that.form.id) {
            that.update();
          } else {
            that.add();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleChange(value) {
      console.log(value);
    },
    async init(res) {
      //获取父级部门列表
      officeListApi().then(res => {
        this.options = res;
      })
      
      if (res) {
        //获取部门详情
        await officeOneApi(res.id).then(res => {
          this.form = res;
        });
      } else {
        //清空form
        for(var i in this.form) {
          this.form[i] = "";
        }
        this.form.parent = {
          id:""
        }
      }

      this.diaLogName = true;
    },
    cancel() {
      this.diaLogName = false;
    },
    add() {
      let { form, cancel, $parent } = this;
      officeAddApi(form).then(res => {
        cancel();
        elMsg("新增成功");
        $parent.getData();
      });
    },
    update() {
      let {
        form: { id },
        form,
        cancel,
        $parent
      } = this;
      officePutApi(id, form).then(res => {
        cancel();
        elMsg("修改成功");
        $parent.getData();
      });
    }
  }
};
</script>

<style lang='less' scoped></style>